import { jkLoomDark, jkLoomLight } from './jkLoomTokens';

const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: jkLoomLight.primary,
      light: jkLoomLight.primaryFixed,
      dark: jkLoomLight.primaryContainer,
      contrastText: jkLoomLight.onPrimary,
    },
    secondary: {
      main: jkLoomLight.secondary,
      light: jkLoomLight.secondaryContainer,
      dark: '#444655',
      contrastText: '#ffffff',
    },
    success: {
      main: jkLoomLight.success,
      light: 'rgba(0, 200, 117, 0.12)',
      dark: '#00a861',
      contrastText: '#ffffff',
    },
    info: {
      main: '#7b41b3',
      light: jkLoomLight.primaryFixed,
      dark: jkLoomLight.primaryContainer,
      contrastText: '#ffffff',
    },
    error: {
      main: jkLoomLight.statusError,
      light: jkLoomLight.errorContainer,
      dark: jkLoomLight.error,
      contrastText: '#ffffff',
    },
    warning: {
      main: jkLoomLight.tertiaryDim,
      light: '#ffdeae',
      dark: jkLoomLight.tertiary,
      contrastText: '#291900',
    },
    purple: {
      A50: jkLoomLight.primaryFixed,
      A100: jkLoomLight.primaryContainer,
      A200: jkLoomLight.primary,
    },
    grey: {
      100: jkLoomLight.surfaceContainer,
      200: '#eae7e7',
      300: jkLoomLight.outlineVariant,
      400: jkLoomLight.outline,
      500: jkLoomLight.onSurfaceVariant,
      600: jkLoomLight.onSurface,
    },
    text: {
      primary: jkLoomLight.onSurface,
      secondary: jkLoomLight.onSurfaceVariant,
    },
    action: {
      disabledBackground: 'rgba(27, 27, 28, 0.08)',
      hoverOpacity: 0.04,
      hover: jkLoomLight.surfaceContainer,
    },
    divider: jkLoomLight.divider,
    background: {
      default: jkLoomLight.parchment,
      paper: jkLoomLight.card,
    },
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: jkLoomDark.primary,
      light: jkLoomDark.primaryContainer,
      dark: '#622599',
      contrastText: jkLoomDark.onPrimary,
    },
    secondary: {
      main: jkLoomDark.secondary,
      light: jkLoomDark.secondaryContainer,
      dark: '#191b29',
      contrastText: jkLoomDark.deep,
    },
    success: {
      main: jkLoomDark.success,
      light: 'rgba(0, 200, 117, 0.16)',
      dark: '#00a861',
      contrastText: '#ffffff',
    },
    info: {
      main: '#ba7ef4',
      light: jkLoomDark.primaryContainer,
      dark: '#4b0082',
      contrastText: '#ffffff',
    },
    error: {
      main: jkLoomDark.statusError,
      light: jkLoomDark.errorContainer,
      dark: '#ff5449',
      contrastText: '#ffffff',
    },
    warning: {
      main: jkLoomDark.tertiary,
      light: '#604100',
      dark: '#c98e1c',
      contrastText: '#281900',
    },
    purple: {
      A50: jkLoomDark.primaryContainer,
      A100: jkLoomDark.primary,
      A200: '#ba7ef4',
    },
    grey: {
      100: jkLoomDark.surfaceElevated,
      200: jkLoomDark.surface,
      300: jkLoomDark.outlineVariant,
      400: jkLoomDark.outline,
      500: jkLoomDark.onSurfaceVariant,
      600: jkLoomDark.onSurface,
    },
    text: {
      primary: jkLoomDark.onSurface,
      secondary: jkLoomDark.onSurfaceVariant,
    },
    action: {
      disabledBackground: 'rgba(243, 240, 239, 0.08)',
      hoverOpacity: 0.06,
      hover: jkLoomDark.surfaceElevated,
    },
    divider: jkLoomDark.divider,
    background: {
      default: jkLoomDark.deep,
      dark: jkLoomDark.deep,
      paper: jkLoomDark.card,
    },
  },
};

export { baseDarkTheme, baselightTheme };
